import { format, isValid, parse } from 'date-fns';
import { formatPercent, maskCurrency, maskDate } from '@ibk/shared-utils';
export function useChargesInformationForm({ onChange }) {
    const handleAmountChange = (value) => {
        const formattedValue = maskCurrency(value);
        onChange('amount', formattedValue);
    };
    const handlePercentageChange = (field, value) => {
        const numbers = value.replace(/\D/g, '');
        if (!numbers) {
            onChange(field, '');
            return;
        }
        const cleanValue = value.replace(/%/g, '');
        const cleanNumbers = cleanValue.replace(/\D/g, '');
        if (!cleanNumbers) {
            onChange(field, '');
            return;
        }
        const numberValue = parseInt(cleanNumbers, 10) / 100;
        const formattedValue = formatPercent(numberValue, false);
        onChange(field, formattedValue);
    };
    const handleDiscountValueChange = (value) => {
        const formattedValue = maskCurrency(value);
        onChange('discountValue', formattedValue);
    };
    const handleDateChange = (field, value) => {
        const formattedValue = maskDate(value);
        onChange(field, formattedValue);
    };
    const handleCalendarDateChange = (field, isoDate) => {
        const [year, month, day] = isoDate.split('-').map(Number);
        const date = new Date(year, month - 1, day);
        const formattedValue = format(date, 'dd/MM/yyyy');
        onChange(field, formattedValue);
    };
    const getCalendarInitialDate = (field, currentValue) => {
        if (!currentValue)
            return undefined;
        const parsedDate = parse(currentValue, 'dd/MM/yyyy', new Date());
        if (!isValid(parsedDate))
            return undefined;
        return format(parsedDate, 'yyyy-MM-dd');
    };
    const handleToggleChange = (field, value) => {
        onChange(field, value);
    };
    const handleRadioChange = (field, value) => {
        onChange(field, value);
    };
    return {
        handleAmountChange,
        handlePercentageChange,
        handleDiscountValueChange,
        handleDateChange,
        handleCalendarDateChange,
        getCalendarInitialDate,
        handleToggleChange,
        handleRadioChange,
    };
}
